import AreaInput from "./AreaInput";

export default AreaInput;
